import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type { InputNumberProps } from 'ant-design-vue'

import type NumberRange from './number-range.vue'

export const numberRangeProps = buildProps({
  value: {
    type: definePropType<InputNumberProps['value'][] | null>([Array, null]),
    default: () => [],
  },
  min: Number,
  max: Number,
  minMaxRange: {
    type: Array,
    default: () => [],
  },

  precision: {
    type: definePropType<InputNumberProps['precision']>(Number),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: Array,
    default: () => ['最小值', '最大值'],
  },
  // 最小值占位符
  startPlaceholder: {
    type: String,
    default: '',
  },
  // 最大值占位符
  endPlaceholder: {
    type: String,
    default: '',
  },
  // 间隔符
  separator: {
    type: String,
    default: '-',
  },
  // 校准起始与结束值大小
  calibrateSize: {
    type: Boolean,
    default: true,
  },
  isGray: {
    type: Boolean,
    default: false,
  },
  step: {
    type: definePropType<InputNumberProps['step']>([Number, String]),
    default: 1,
  },
  size: String,
} as const)

export const numberRangeEmits = {
  change: (value: InputNumberProps['value'][]) =>
    !!value || typeof value === 'number',
  'update:value': (value: InputNumberProps['value'][]) =>
    !!value || typeof value === 'number',
} as const

// props
export type NumberRangeProps = ExtractPropTypes<typeof numberRangeProps>

// emits
export type NumberRangeEmits = typeof numberRangeEmits

// instance
export type NumberRangeInstance = InstanceType<typeof NumberRange>
